// Include under theme.js like this : <script src="{{ 'custom-grid.js' | asset_url }}" defer="defer"></script>

//Calling the function for the sections with the class tw-featured-collection-container and data-slider-type = slider
let sections = document.querySelectorAll('.tw-featured-collection-container[data-slider-type="slider"]');
  
sections.forEach((section) => {
  let sectionId = section.id;  // Assuming each section has a unique ID
  initSlider(sectionId);
});

// Function to initialize scroll functionality for each section
function initSlider(sectionId) {
  let buttons = document.querySelectorAll(`#${sectionId} .tw-featured-collection-buttons button`);
  let wrapper = document.querySelector(`#${sectionId} .tw-featured-collection-wrapper`);
  let card = document.querySelector(`#${sectionId} .custom-product-grid-item`);
  let cardWidth = card.offsetWidth;

  // Function to toggle button states based on scroll position
  function toggleButtonState() {
    let prevButton = document.querySelector(`#${sectionId} button[data-action="prev"]`);
    let nextButton = document.querySelector(`#${sectionId} button[data-action="next"]`);

    // Disable the 'prev' button if scrolled to the leftmost point
    if (wrapper.scrollLeft <= 0) {
      prevButton.disabled = true;
    } else {
      prevButton.disabled = false;
    }

    // Disable the 'next' button if scrolled to the rightmost point
    if (wrapper.scrollLeft + wrapper.offsetWidth >= wrapper.scrollWidth) {
      nextButton.disabled = true;
    } else {
      nextButton.disabled = false;
    }
  }

  // Initial toggle to set the correct button states on load
  toggleButtonState();

  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      if (button.getAttribute('data-action') === 'next') {
        wrapper.scrollLeft += cardWidth; // Scrolls to the right
      } else if (button.getAttribute('data-action') === 'prev') {
        wrapper.scrollLeft -= cardWidth; // Scrolls to the left
      }
    });
  });

  // Listen to scroll event to toggle button states
  wrapper.addEventListener('scroll', toggleButtonState);
}
